// src/admin/components/HomePageConfig/FontSizeSection.jsx
import React from "react";

export default function FontSizeSection({
  title,
  sizes = {},
  onChange,
  useSectionFontSizes = false,
  onToggleSectionFontSizes,
  fields = [],
}) {
  if (!fields.length) return null;

  const handleChange = (key, value) => {
    if (onChange) onChange(key, value);
  };

  return (
    <div
      className="hcfg-fontsize-section"
      style={{
        marginTop: "20px",
        padding: "15px",
        background: "#f9f9f9",
        borderRadius: "8px",
        border: "1px solid #eee",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h4
          style={{
            color: "#333",
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {title} Font Sizes
          <span
            style={{
              fontSize: "12px",
              backgroundColor: "#eef5ff",
              color: "#1e4ed8",
              padding: "2px 8px",
              borderRadius: "12px",
              fontWeight: "normal",
            }}
          >
            Leave blank to use global size
          </span>
        </h4>

        {onToggleSectionFontSizes && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: useSectionFontSizes ? "#e8f5e9" : "#f5f5f5",
              padding: "8px 15px",
              borderRadius: "20px",
              border: `1px solid ${useSectionFontSizes ? "#4CAF50" : "#ddd"}`,
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              <input
                type="checkbox"
                checked={useSectionFontSizes}
                onChange={(e) => onToggleSectionFontSizes(e.target.checked)}
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                  accentColor: "#4CAF50",
                }}
              />
              <span
                style={{
                  fontSize: "14px",
                  color: "#333",
                  fontWeight: "500",
                }}
              >
                Use Section Font Sizes
              </span>
            </label>
            <span
              style={{
                fontSize: "12px",
                color: useSectionFontSizes ? "#2E7D32" : "#666",
                fontStyle: "italic",
              }}
            >
              {useSectionFontSizes ? "✓ Custom" : "→ Global"}
            </span>
          </div>
        )}
      </div>

      <div
        style={{
          opacity: useSectionFontSizes ? 1 : 0.5,
          pointerEvents: useSectionFontSizes ? "auto" : "none",
        }}
      >
        {!useSectionFontSizes && (
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeaa7",
              borderRadius: "4px",
              padding: "10px",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                color: "#856404",
                fontStyle: "italic",
              }}
            >
              ⓘ Currently using Global Font Sizes. Enable "Use Section Font
              Sizes" to customize this section separately.
            </span>
          </div>
        )}

        <div className="hcfg-row">
          {fields.map((field) => (
            <div key={field.key} className="hcfg-col">
              <label>{field.label}</label>
              <input
                type="text"
                value={sizes?.[field.key] || ""}
                onChange={(e) => handleChange(field.key, e.target.value)}
                placeholder={field.placeholder || "e.g., 32px"}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
